// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"42":"2511ac1b60522c0962cc","260":"90afa6fda7b3878f2fb6","702":"80fdd4fa977a405ead59","715":"4d956a6cec979981eebf"}[chunkId] + ".css";
};